import { toast } from 'sonner';

const WARM_EVENTS = ['scroll', 'mousemove', 'touchstart', 'click'];
const POLL_MS = 250;
const TIMEOUT_MS = 12000;

const api = () => window.leadConnector?.chatWidget;
const widgetRoot = () => document.querySelector('chat-widget')?.shadowRoot;

const tryOpen = () => {
  const widget = api();
  if (widget?.openWidget) {
    widget.openWidget();
    return true;
  }
  const launcher = widgetRoot()?.querySelector('#lc_text-widget--btn');
  if (launcher) {
    launcher.click();
    return true;
  }
  return false;
};

// The LeadConnector loader defers the widget until the first user interaction; nudge it early.
export function warmChatWidget() {
  if (api() || document.querySelector('chat-widget')) return;
  WARM_EVENTS.forEach((type) => {
    window.dispatchEvent(new Event(type));
    document.dispatchEvent(new Event(type, { bubbles: true }));
  });
}

export function closeChatWidget() {
  api()?.closeWidget?.();
}

const chatInput = () => widgetRoot()?.querySelector('chat-pane')?.shadowRoot?.querySelector('chat-input')?.shadowRoot;

// Types a message into the (Ionic) chat textarea so the visitor only has to tap Send.
function prefillChat(text, attempt = 0) {
  const root = chatInput();
  const textarea = root?.querySelector('textarea');
  if (!textarea) {
    if (attempt < 16) setTimeout(() => prefillChat(text, attempt + 1), POLL_MS);
    return;
  }
  const ionTextarea = root.querySelector('ion-textarea');
  if (ionTextarea) ionTextarea.value = text;
  textarea.value = text;
  textarea.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
  textarea.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  textarea.focus();
}

let pending = null;

// Opens the site-wide LeadConnector chat widget, waiting for it to initialise if needed.
export function openChatWidget(prefill) {
  const text = typeof prefill === 'string' ? prefill : null;
  const done = () => { if (text) setTimeout(() => prefillChat(text), 300); };
  if (tryOpen()) { done(); return; }
  if (pending) return;
  warmChatWidget();
  const toastId = toast.loading('Connecting you to the AI Concierge…');
  const started = Date.now();
  pending = setInterval(() => {
    if (tryOpen()) {
      clearInterval(pending);
      pending = null;
      toast.dismiss(toastId);
      done();
    } else if (Date.now() - started > TIMEOUT_MS) {
      clearInterval(pending);
      pending = null;
      toast.error('The AI Concierge is taking longer than usual. Please try again or call 800 EUROPCAR.', { id: toastId });
    }
  }, POLL_MS);
}
